import { generatePath } from 'react-router';
import { observer } from 'mobx-react';
import cls from 'classnames';

import CollectionNavItem from '@/common/components/Header/CollectionNavItem/CollectionNavItem';
import PinNavItem from '@/common/components/Header/PinNavItem/PinNavItem';
import Icon from '@/common/components/Icon/Icon';
import Link, { NONE } from '@/common/components/Link/Link';
import { DRIVE_PAGE } from '@/common/constants/pages';
import { Rollout } from '@/common/constants/rollouts';
import { useUserStore } from '@/user/stores/UserStore';

import headerStyles from '../Header.module.css';

import styles from './CollectionOrDriveNavItem.module.css';

function CollectionOrDriveNavItem() {
  const userStore = useUserStore();

  if (!userStore.isAuthorized) {
    return null;
  }

  if (!userStore.user?.hasRollout(Rollout.Drive)) {
    return <CollectionNavItem />;
  }

  return (
    <>
      <PinNavItem />

      <Link
        appearance={NONE}
        aria-label="Link to collections page"
        className={cls(headerStyles.headerLink, headerStyles.headerLinkIcon, styles.driveLink)}
        to={generatePath(DRIVE_PAGE)}
      >
        <Icon name="like" />
      </Link>
    </>
  );
}

export default observer(CollectionOrDriveNavItem);
